import React from 'react'
import MintGUI from '../../components/mintgui/MintGUI'


import './mintpage.css'

const MintPage = () => {
  return (
    <div className='mintpage'>
      <MintGUI />
    </div>
  )
}

export default MintPage
